<template>
    <div>
        <div class="tab__header">
            <a href="#" class="p-2 block hover:bg-grey-lighter no-underline text-black border-b-2 border-grey-500 flex justify-between" @click.prevent="active = !active">
                {{title}}
                <span class="down-Arrow" v-show="!active">&#9660;</span>
                <span class="up-Arrow" v-show="active">&#9650;</span>
            </a>
        </div>
        <div class="p-2" v-show="active"><slot /></div>
    </div>
</template>
<script>
    export default {
        name: "accordion",
        props: [
            'title'
        ],
        data() {
            return {
                active: false,
                list: {}
            };
        },
    };
</script>